import React from 'react';
import { ShopCart, User } from '../../models';
import { useEditShopCart, useShopCartTally } from '../../hooks';
import ShopcartButtons from './ShopcartButtons';
import ShopcartSummary from './ShopcartSummary/ShopcartSummary';
import Alert from '../shared/Alert/Alert';

interface ShopcartProps {
  shopCart: ShopCart;
  users: User[];
}

function Shopcart({ shopCart, users }: ShopcartProps) {
  const {
    productsShopItems,
    benefitsShopItems,
    plansShopItems,
    editShopCart,
    loading,
  } = useEditShopCart(shopCart);

  const total = useShopCartTally({
    shopCart,
    productsShopItems,
    benefitsShopItems,
    plansShopItems,
    appliedDiscounts: [],
  });

  const shopCartIsEmpty =
    shopCart.benefits.length === 0 &&
    shopCart.products.length === 0 &&
    shopCart.subscriptions.length === 0;

  return (
    <div className="w-full flex flex-wrap gap-5 lg:gap-0">
      {shopCartIsEmpty ? (
        <Alert
          title="Tu carrito de compras esta vacio"
          text="Agregar productos, suscripciones y beneficios a tu carrito de compras"
          show
        />
      ) : (
        <>
          <div className="w-full lg:w-2/3 lg:pr-5">
            <ShopcartSummary
              productsShopItems={productsShopItems}
              benefitsShopItems={benefitsShopItems}
              plansShopItems={plansShopItems}
              editShopCart={editShopCart}
              shopCart={shopCart}
              total={total}
              loading={loading}
            />
          </div>
          <div className="w-full lg:w-1/3 lg:pl-5 flex flex-col space-y-5">
            <ShopcartButtons />
          </div>
        </>
      )}
    </div>
  );
}

export default Shopcart;
